export enum AppModule {
  Dashboard = 'Dashboard',
  Messages = 'Message',
  Profile = 'Profile',
  Task = 'Task',
  Notifications = 'Notifications',
  /* Start: From Database */

  Patient = 'Patient',
  ActivePatient = 'ActivePatient',
  VisitNotes = 'VisitNotes',
  InvestigationResults = 'InvestigationResults',
  Referrals = 'Referrals',
  Calendar = 'Calendar',
  Invoice = 'Invoice',
  Professionals = 'Professionals',
  Reports = 'Reports',
  Settings = 'Settings',
  Admin = 'Admin',
  Master = 'Master',
  Templates = 'Templates',
  RequestedReschedule = 'RequestedReschedule',
  /* End: From Database */
}
